import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  SessionDetailResponse,
  SessionFilters,
  SessionSummary,
  SessionType,
} from '../models/session.types';

@Injectable({
  providedIn: 'root',
})
export class SessionsService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  public errorMessage = signal<string | null>(null);

  public filters = signal<SessionFilters>({ organisations: [], users: [] });
  public sessions = signal<SessionSummary[]>([]);
  public total = signal(0);

  loadFilters(search?: string) {
    let params = new HttpParams();
    if (search?.trim()) params = params.set('search', search.trim());
    this.http
      .get<SessionFilters>(`${this.apiUrl}/backoffice/sessions/filters`, { params })
      .subscribe({
        next: (data) => this.filters.set(data),
        error: (err) => this.errorMessage.set(err.message),
      });
  }

  loadSessions(
    startDate: Date,
    endDate: Date,
    orgId?: number,
    userId?: number,
    search?: string,
    page = 0,
    pageSize = 20,
  ) {
    let params = new HttpParams()
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString())
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (orgId) params = params.set('organisationId', orgId.toString());
    if (userId) params = params.set('userId', userId.toString());
    if (search?.trim()) params = params.set('search', search.trim());

    this.http
      .get<{ data: SessionSummary[]; total: number; page: number; pageSize: number }>(
        `${this.apiUrl}/backoffice/sessions`,
        { params },
      )
      .subscribe({
        next: (response) => {
          this.sessions.set(response.data);
          this.total.set(response.total);
        },
        error: (err) => this.errorMessage.set(err.message),
      });
  }

  getSessionDetail(sessionId: string, type: SessionType) {
    const params = new HttpParams().set('sessionId', sessionId).set('type', type);

    return this.http.get<SessionDetailResponse>(`${this.apiUrl}/backoffice/sessions/detail`, {
      params,
    });
  }

  exportScenario(sessionId: string) {
    const params = new HttpParams().set('sessionId', sessionId);
    return this.http.get<Record<string, unknown>>(
      `${this.apiUrl}/backoffice/sessions/export-scenario`,
      { params },
    );
  }
}
